module.exports = __webpack_public_path__ + "img/_logo.df7dd02a.svg";